import React from 'react';
import {useTranslation} from 'react-i18next';
import {EButton} from 'webapp-lib/Components';

import {MissingEntry} from '_/assets/images';
import {withStyle} from '_/utilities/types';

import {StyledDescription, StyledHeader, StyledPlaceholder} from './styles';

export interface Props {
  className?: string;
  PlaceholderImage?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  placeholderHeader?: string;
  description?: string;
  actions?: React.ReactElement<typeof EButton>[];
  noImage?: boolean;
}

export function PlaceholderComponent({
  className,
  PlaceholderImage,
  placeholderHeader,
  description,
  actions,
  noImage,
}: Props): React.ReactElement {
  const {t} = useTranslation('common');
  const headerText = placeholderHeader ?? t('placeholder.header.defaultText');

  return noImage ? (
    <div className={className}>{headerText}</div>
  ) : (
    <div className={className}>
      {PlaceholderImage ? (
        <PlaceholderImage />
      ) : (
        <MissingEntry data-testid='Icon-MissingEntry' />
      )}
      {description ? <hr /> : null}
      <StyledHeader>{headerText}</StyledHeader>
      {description ? (
        <StyledDescription>{description}</StyledDescription>
      ) : null}
      {actions}
    </div>
  );
}

export default withStyle(PlaceholderComponent, StyledPlaceholder);
export {StyledHeader} from './styles';
